/**
 * Tax code form rules (owner 2026-10-22, Settings > Billing > Tax Rate). Same limits as the
 * server (`TaxCodeEdit`): a name, 1-10 rates, each 0-100%. null = fine.
 */
export const MAX_TAX_RATES = 10;

export const taxCodeProblem = (
  name: string,
  rates: number[],
): string | null => {
  if (!name.trim()) return "Enter a tax code name.";
  if (name.trim().length > 100)
    return "The tax code name can be at most 100 characters.";
  if (!rates.length) return "Add at least one tax rate.";
  if (rates.length > MAX_TAX_RATES)
    return `A tax code can have at most ${MAX_TAX_RATES} rates.`;
  if (rates.some((rate) => Number.isNaN(rate) || rate < 0 || rate > 100))
    return "A tax rate must be between 0 and 100%.";
  return null;
};
